/*
 * Copyright © 2017 TEKTELIC Communications Inc.
 */


/*@ngInject*/
export default function AddCustomerController($scope, $rootScope, $mdDialog, $state, $stateParams, $document, $q, types, customerService,
                                                 geoService, entityTableConfiguration) {

    var vm = this;

    vm.$onInit = function () {
        const defaultResolverConfiguration = {
            antennaCombiningMethod: 'MIN_TOA',
            createdAt: 0,
            customerId: '',
            id: '',
            maxRssiThreshold: 0,
            minRssiThreshold: 0,
            minSnrThreshold: 0,
            tdoaThreshold: 0,
            uncertaintyThreshold: 0,
            updatedAt: 0,
            weightingMethod: 'EQUAL'
        };

        const defaultAlgorithmConfiguration = {
            id: '',
            customerId: '',
            createdAt: 0,
            updatedAt: 0,
            alpha0: 0,
            beta: 0,
            gamma: 0,
            maxNorm: 0,
            distanceErrorTolerance: 0,
            btlsMaxIterNumber: 0,
            gdMaxIterNumber: 0,
            gnMaxIterNumber: 0,
            regularizationParameter: 0,
            pathLossExp: 0
        };

        vm.entityTableConfiguration = entityTableConfiguration;

        vm.entity = {
            resolverConfiguration: {},
            algorithmConfiguration: {},
        };

        if ($rootScope.defaultResolverConfiguration) {
            vm.entity.resolverConfiguration = angular.copy($rootScope.defaultResolverConfiguration);
        } else {
            geoService.getDefaultResolverConfiguration().then(
                (config) => {
                    $rootScope.defaultResolverConfiguration = angular.copy(config);
                    vm.entity.resolverConfiguration = config;
                },
                () => vm.entity.resolverConfiguration = defaultResolverConfiguration
            );
        }

        if ($rootScope.defaultAlgorithmConfiguration) {
            vm.entity.algorithmConfiguration = angular.copy($rootScope.defaultAlgorithmConfiguration);
        } else {
            geoService.getDefaultAlgorithmConfiguration().then(
                (config) => {
                    $rootScope.defaultAlgorithmConfiguration = angular.copy(config);
                    vm.entity.algorithmConfiguration = config;
                },
                () => vm.entity.algorithmConfiguration = defaultAlgorithmConfiguration
            );
        }

        vm.entityType = vm.entityTableConfiguration.entityType;
        vm.translations = types.entityTypeTranslations[vm.entityType];

        vm.add = add;
        vm.cancel = cancel;
    };

    function cancel() {
        $mdDialog.cancel();
    }

    function add() {
        var newResolverConfiguration = vm.entity.resolverConfiguration;
        var newAlgorithmConfiguration = vm.entity.algorithmConfiguration;

        customerService.saveCustomer(vm.entity).then(
            (customer) => {
                vm.entity = customer;
                newResolverConfiguration.customerId = customer.id.id;
                newAlgorithmConfiguration.customerId = customer.id.id;

                geoService.createResolverConfiguration(customer.id.id, newResolverConfiguration).then(
                    (resolverConfiguration) => {
                        vm.entity.resolverConfiguration = resolverConfiguration;
                        $scope.theForm.$setPristine();
                        $mdDialog.hide();
                    },
                    () => vm.entity.resolverConfiguration = newResolverConfiguration
                );

                geoService.createAlgorithmConfiguration(customer.id.id, newAlgorithmConfiguration).then(
                    (algorithmConfiguration) => {
                        vm.entity.algorithmConfiguration = algorithmConfiguration;
                        $scope.theForm.$setPristine();
                        $mdDialog.hide();
                    },
                    () => vm.entity.algorithmConfiguration = newAlgorithmConfiguration
                );
            }
        );
    }
}



// WEBPACK FOOTER //
// ./src/app/customer/add-customer.controller.js